module.exports = __webpack_public_path__ + "7e3295b376f00d6df8c9a3445d2357ce.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/font/NanumGothic.ttf
// module id = 595
// module chunks = 0